import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CookieModule, CookieService } from 'ngx-cookie';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { metaReducers, rootEffects, rootReducer } from '@app/store';
import { NgxMaskModule } from 'ngx-mask';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { ErrorsPopupModule } from '@shared/popups/error-popups/errors-popup.module';
import { FeedbackModule } from './feedback/feedback.module';
import { BackendApiMonitoringMetadoorInvestModule } from './backend/monitoring-metadoor-invest-api-client';
import { BackendApiAnalyticsMetadoorInvestModule } from './backend/analytics-metadoor-invest-api-client/backend-api-analytics-metadoor-invest.module';
import { AnalyticsAuthInterceptor } from './analytics/interceptors/analytics-auth.interceptor';
import { OptimizerAuthInterceptor } from './portfolios/interceptors/optimizer-auth.interceptor';
import { of } from 'rxjs';
import { DICTIONARY_PROVIDER } from '@common/dictionaries';
import { BackendApiMetadoorModule } from '@app/backend/metadoor-api-client/backend-api-metadoor.module';
import { provideTranslateService, TranslateModule, TranslateService } from '@ngx-translate/core';
import { translateInitializerFactory, TranslationConfig } from '@app/translate';
import { authInterceptorFactory } from '@app/interceptors';
import { ErrorsService } from '@app/errors/errors.service';
import { enumInterceptor } from '@app/interceptors/enum.interceptor';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { AccessModule } from '@app/access/access.module';

registerLocaleData(localeRu);

// export const NAV_BTN_CLICK_SELECTOR = new InjectionToken('SelectNavBtnClick');

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    CookieModule.withOptions(),
    StoreModule.forRoot(rootReducer, { metaReducers }),
    EffectsModule.forRoot(rootEffects),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    NgxMaskModule.forRoot(),
    HttpClientModule,
    ErrorsPopupModule,
    FeedbackModule,
    BackendApiMonitoringMetadoorInvestModule.forRoot({ rootUrl: environment.monitoringUrl }),
    BackendApiAnalyticsMetadoorInvestModule.forRoot({ rootUrl: environment.analyticsApiUrl }),
    BackendApiMetadoorModule.forRoot({ rootUrl: environment.baseUrl }),
    TranslateModule.forRoot(TranslationConfig),
    AccessModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: translateInitializerFactory,
      deps: [TranslateService, Store],
      multi: true,
    },
    {
      provide: DICTIONARY_PROVIDER,
      useFactory: () => ({
        getDictionaryValuesByType() {
          return of([]);
        },
      }),
    },
    provideTranslateService(TranslationConfig),
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: authInterceptorFactory,
      deps: [CookieService, ErrorsService, Injector, Store],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AnalyticsAuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OptimizerAuthInterceptor,
      multi: true,
    },
    // use without merging with locale
    // {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    provideHttpClient(withInterceptors([enumInterceptor])),

    // if we has warning 'Blocked aria-hidden on an element' use:
    //   {
    //     provide: DialogService,
    //     useFactory: (dialog: MatDialog) => new DialogService(dialog),
    //     deps: [MatDialog],
    //   },

    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
        restoreFocus: false,
        hasBackdrop: true,
      } as MatDialogConfig,
    },
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
